import { GetServerSideProps } from 'next';
import Head from 'next/head';
import APIServices from '@/apiUtils/APIServices';

import dynamic from 'next/dynamic';
const ErrorPage = dynamic(() => import('../404'));
const TutorDescription = dynamic(() => import('@/components/landing/tutor/all-tutors/TutorDescription'));
const LandingLayout = dynamic(() => import('@/components/landing/home/LandingLayout'), { ssr: false });

const TutorProfile = (props) => {
  if (props.data === null) {
    return <ErrorPage />;
  }

  return (
    <>
      <Head>
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_SITE_URL}tutor/${props?.username}`}
        />
      </Head>
      <LandingLayout>
        <TutorDescription {...props} />
      </LandingLayout>
    </>
  );
};

export default TutorProfile;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const username = context.query?.username;
  const { data, success } = await new APIServices(
    `instructor-list/${username}`
  ).get();
  return {
    props: {
      data: success ? data : null,
      username,
    },
  };
};
